import { isEmptyString } from '../string-utils'

export const Servers = Object.freeze({
  STRATEGY_GATEWAY: Object.freeze({
    url: process.env.REACT_APP_API_GATEWAY_URL as string,
    version: process.env.REACT_APP_API_GATEWAY_VERSION ?? '',
  }),
  STRATEGY_BASE: Object.freeze({
    url: process.env.REACT_APP_STRATEGY_BASE_URL as string,
    version: process.env.REACT_APP_STRATEGY_VERSION ?? '',
  })
})

export function isProductionEnv (): boolean {
  const isProdNodeEnv = process.env.NODE_ENV === 'production'
  const isProdReactEnv = process.env.REACT_APP_ENVIRONMENT === 'production'
  return (isProdNodeEnv || isProdReactEnv)
}

export function isUsingProdDataRoutes (): boolean {
  const isProdNodeEnv = process.env.NODE_ENV === 'production'
  const isProdOrStagingReactEnv = process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.REACT_APP_ENVIRONMENT === 'staging'
  return (isProdNodeEnv || isProdOrStagingReactEnv)
}

/**
 * Filters out dangerous control api urls when the specified conditions are met
 * @param route route to check
 * @return route if valid; if invalid: an empty string
 */
function filterDangerousApis (route: string): string {
  return route
}

/**
 * Forms the given strategy's server url given its strategyId
 * @param strategyId strategyId of the desired strategy
 * @return strategyServerUrl url pointing to the strategy server
 */
export function getStrategyServerUrl (strategyId: string): string {
  if (isUsingProdDataRoutes()) {
    return `${Servers.STRATEGY_BASE.url}/${strategyId}`
  } else {
    return `${Servers.STRATEGY_BASE.url}`
  }
}

/**
 * Forms the given strategy's api url given its strategyId and route
 *
 * Note: The route should include any collection prefixes, but exclude everything before the version prefix
 * @param strategyId strategyId of the desired strategy
 * @param route route used to form the api url
 * @return apiUrl full api url if valid; if invalid: an empty string
 */
export function formStrategyApiUrl (strategyId: string, route: string): string {
  const checkedRoute = filterDangerousApis(route)
  if (isEmptyString(checkedRoute)) {
    return ''
  }

  if (isUsingProdDataRoutes()) {
    return `${Servers.STRATEGY_BASE.url}/${strategyId}/api/${Servers.STRATEGY_BASE.version}/${route}`
  } else {
    if (isEmptyString(Servers.STRATEGY_BASE.version)) {
      return `${Servers.STRATEGY_BASE.url}/api/${route}`
    } else {
      return `${Servers.STRATEGY_BASE.url}/api/${Servers.STRATEGY_BASE.version}/${route}`
    }
  }
}

/**
 * Forms the ensemble agent url given its server public IP and strategyId
 * @param ip public IP of strategy server
 * @param strategyId strategyId of the desired strategy
 */
export function formEnsembleBaseUrl (ip: string): string {
  return `https://${ip}:${process.env.REACT_APP_ENSEMBLE_PORT ?? '37105'}/ensemble/strategy`
}

/**
 * Forms the api gateway's api url given its route
 *
 * Note: The route should include any collection prefixes, but exclude everything before the version prefix
 * @param route route used to form the api url
 * @return apiUrl full api url if valid; if invalid: an empty string
 */
export function formApiGatewayApiUrl (route: string): string {
  if (isUsingProdDataRoutes()) {
    return `${Servers.STRATEGY_GATEWAY.url}/api/${Servers.STRATEGY_GATEWAY.version}/${route}`
  } else {
    if (isEmptyString(Servers.STRATEGY_GATEWAY.version)) {
      return `${Servers.STRATEGY_GATEWAY.url}/api/${route}`
    } else {
      return `${Servers.STRATEGY_GATEWAY.url}/api/${Servers.STRATEGY_GATEWAY.version}/${route}`
    }
  }
}
